// Partage discret d'une séance sans exposer de données personnelles.
// Utilise Web Share API si disponible, sinon copie le lien dans le presse-papiers.

export async function shareSession(session) {
  const url = `${window.location.origin}/lecteur/${encodeURIComponent(session.id)}`;
  const title = `${session.title} · Soft Landing ASMR`;
  const text = `${session.title} — ${session.minutes} min pour retrouver le calme.`;

  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return { ok: true, mode: "share" };
    } catch (e) {
      // L'utilisateur a annulé — pas d'erreur à remonter
      if (e && e.name === "AbortError") return { ok: false, mode: "cancelled" };
      // Fall through to clipboard
    }
  }

  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(url);
      return { ok: true, mode: "clipboard", url };
    }
  } catch (e) { /* ignore */ }

  return { ok: false, mode: "unsupported", url };
}
